import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "rounded" }
const _hoisted_2 = { class: "bg-brand-lightGrey rounded-lg m-1 p-4" }
const _hoisted_3 = { class: "flex flex-row text-sm justify-between" }
const _hoisted_4 = { class: "text-xs" }
const _hoisted_5 = { class: "text-lg text-center pb-1" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "mr-2 fas fa-arrow-left" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Previous ")
const _hoisted_9 = { class: "flex-grow text-center text-bold text-brand-darkBlue" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Next")
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "ml-2 fas fa-arrow-right" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("table", {
        class: ["text-left w-full text-gray-900", { 'mb-4': _ctx.controls }]
      }, [
        _createVNode("tbody", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedScores, (comment, index) => {
            return (_openBlock(), _createBlock("tr", { key: index }, [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", _hoisted_3, [
                  _createVNode("div", null, [
                    _createVNode("p", null, _toDisplayString(comment.name), 1),
                    _createVNode("p", _hoisted_4, _toDisplayString(comment.organisation), 1)
                  ]),
                  _createVNode("p", null, _toDisplayString(_ctx.ISOtoDateGB(comment.date)), 1)
                ]),
                _createVNode("p", _hoisted_5, _toDisplayString(comment.comment), 1)
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ], 2)
    ]),
    (_ctx.controls)
      ? (_openBlock(), _createBlock("div", _hoisted_6, [
          _createVNode("button", {
            class: ["flex-shrink text-brand-darkBlue button", { disabled: _ctx.currentPage <= 1 }],
            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.prevPage(...args)))
          }, [
            _hoisted_7,
            _hoisted_8
          ], 2),
          _createVNode("p", _hoisted_9, " Page " + _toDisplayString(_ctx.currentPage) + " of " + _toDisplayString(Math.ceil(this.asArray.length / _ctx.pageSize)), 1),
          _createVNode("button", {
            class: ["flex-shrink text-brand-darkBlue button", { disabled: !_ctx.isANextPage }],
            onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.nextPage(...args)))
          }, [
            _hoisted_10,
            _hoisted_11
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}